import {
  authorizationScopes,
  RoleAuthorizationScope,
  RoleAuthorizationScopeValue,
} from 'lib-shared-user-role';

const sections = Object.keys(authorizationScopes);

/** Scope value -> label map */
const labelMap = Object.fromEntries(
  sections.flatMap((section) =>
    authorizationScopes[section].map(({ value, label }) => [value, label]),
  ),
);

/**
 * Scope value -> description map, including the description for required scopes
 * (if exists)
 */
const descriptionMap = sections.reduce((scopes, section) => {
  authorizationScopes[section].forEach(
    ({ value, description, requiredScopes }: RoleAuthorizationScope) => {
      scopes[value] = description;
      scopes[value] += requiredScopes?.length
        ? `${
            description.endsWith('.') ? '' : '.'
          } In order to be enabled, this permission requires ${requiredScopes
            .map((scope) => `"${labelMap[scope]}"`)
            .join(', ')} to be enabled as well`
        : '';
    },
  );

  return scopes;
}, {} as Record<RoleAuthorizationScopeValue, string>);

/**
 * @param scope
 * @returns Full description with info about required scopes
 */
export function getDescription(scope: RoleAuthorizationScopeValue): string {
  return descriptionMap[scope];
}
